var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"new-alert-badge"},[_vm._v(_vm._s(_vm.$t("overlay-menu.new")))])
}
var staticRenderFns = []

export { render, staticRenderFns }